import { Lock, ArrowRight, Sparkles, CheckCircle2 } from "lucide-react";
import { useLocation } from "wouter";

export default function SubscriptionLockout({ isTrial }) {
  const [, navigate] = useLocation();

  return (
    <div className="fixed inset-0 z-[100] flex items-center justify-center bg-gray-900/60 p-4 backdrop-blur-md animate-in fade-in duration-300">
      <div className="w-full max-w-2xl overflow-hidden rounded-3xl bg-white shadow-2xl ring-1 ring-gray-900/10">
        <div className="relative bg-gradient-to-br from-blue-700 to-indigo-900 px-8 py-12 text-center sm:px-12 sm:py-16">
          <div className="absolute inset-0 bg-[url('https://www.transparenttextures.com/patterns/cubes.png')] opacity-10 mix-blend-overlay"></div>
          <div className="relative mx-auto mb-6 flex h-20 w-20 items-center justify-center rounded-2xl bg-white/10 shadow-inner backdrop-blur-md ring-1 ring-white/20">
            <Lock className="h-10 w-10 text-blue-100" />
          </div>
          <h2 className="relative text-3xl font-bold tracking-tight text-white sm:text-4xl">
            {isTrial ? "Your trial has ended" : "Your subscription has expired"}
          </h2>
          <p className="relative mt-4 text-lg text-blue-100 max-w-lg mx-auto">
            {isTrial 
              ? "We hope you enjoyed Seismic Connect. Choose a plan below to keep your clinic running smoothly without interruption."
              : "Your premium access is currently paused. Please renew your subscription to restore full functionality."}
          </p>
        </div>

        <div className="bg-gray-50 px-8 py-10 sm:px-12 flex flex-col items-center border-t border-gray-100">
          <div className="w-full max-w-md space-y-4">
            <button
              onClick={() => navigate("/settings/subscription")}
              className="group relative flex w-full items-center justify-center gap-2 overflow-hidden rounded-xl bg-blue-600 px-6 py-4 text-base font-semibold text-white shadow-lg shadow-blue-600/20 transition-all hover:bg-blue-700 active:scale-[0.98]"
            >
              <Sparkles className="w-5 h-5 text-blue-200" />
              <span>Choose Subscription Plan</span>
              <ArrowRight className="absolute right-6 h-5 w-5 text-blue-200 transition-transform group-hover:translate-x-1" />
            </button>
            
            <button
              onClick={() => navigate("/settings/payment-billing")}
              className="flex w-full items-center justify-center rounded-xl bg-white px-6 py-4 text-base font-semibold text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 transition-all hover:bg-gray-50 active:scale-[0.98]"
            >
              Update Payment Method
            </button>
          </div>
          
          <div className="mt-8 flex flex-col sm:flex-row items-center justify-center gap-4 sm:gap-8 text-sm text-gray-600 font-medium">
             <div className="flex items-center gap-2">
                <CheckCircle2 className="w-4 h-4 text-emerald-500" />
                <span>Keep patient data secure</span>
             </div>
             <div className="flex items-center gap-2">
                <CheckCircle2 className="w-4 h-4 text-emerald-500" />
                <span>Uninterrupted workflow</span>
             </div>
          </div>
        </div>
      </div>
    </div>
  );
}
